import { Categories, Product } from '@/models';
import { GenericService } from './generic.service';
import apiClient from './client/apiClient';

export interface WebshopProduct {
  id: string;
  name: string;
  mlsId: string;
  category: string;
  image?: string;
}

export class WebshopService extends GenericService<Categories> {
  private organisationalUnit: string;

  constructor(organisationalUnit: string) {
    super(`v1/webshop/${organisationalUnit}/categories`);
    this.organisationalUnit = organisationalUnit;
  }

  async getProducts(categorySlug: string) {
    return await apiClient.get<Product[]>(`${this.endpoint}/${categorySlug}/products`);
  }

  async getAllProducts() {
    return await apiClient.get<Product[]>(`v1/webshop/products/${this.organisationalUnit}`);
  }
}
